import { colors } from "./colors_v2.js";
import { eventHub } from "./eventHub_v2.js";
import { hasDangerousMarkup } from "./escapeHtml_v2.js";

const passedValidations = (html) => {
  if (typeof html === "undefined") {
    console.log("ERROR: The text/html is undefined");
    return false;
  }
  if (html.length === 0) {
    console.log("ERROR: The text is empty");
    return false;
  }
  // Backstop only: user values must already be escaped (see escapeHtml_v2.js)
  if (hasDangerousMarkup(html)) {
    console.log("ERROR: html contains markup that can run code");
    return false;
  }
  return true;
};

const close = () => {
  const ipop = document.getElementById("iPop");
  ipop.style.display = "none";

  const iBehinder = document.getElementById("iBehinder");
  iBehinder.style.display = "none";
  delete iBehinder.dataset.action;

  ipop.innerHTML = "";
};

const render = ({ text, event }) => {
  if (!passedValidations(text)) {
    return { status: 400 };
  }
  const iBehinder = document.getElementById("iBehinder");
  iBehinder.dataset.action = "iBehinderCloseIPop";
  iBehinder.style.display = "block";

  const padding = 30; // minimum distance from edge

  const html = `
  <div class="iOuter">
    <div class ="iInner">
      ${text}
    </div>
    <div class="x" id="iClose"></div>
  </div>
  `;
  const iPop = document.getElementById("iPop");
  iPop.style.display = "block";
  iPop.classList.add("animate-pop");

  iPop.innerHTML = html;

  const w = iPop.offsetWidth;
  const h = iPop.offsetHeight;

  // Center the coordinates on the mouse
  let safeX = event.clientX - w / 2;
  let safeY = event.clientY - h / 2;

  // Clamping (Keeping it on screen)

  if (safeX + w > window.innerWidth - padding)
    safeX = window.innerWidth - w - padding;
  if (safeX < padding) safeX = padding;

  if (safeY < padding) safeY = padding;
  if (safeY + h > window.innerHeight - padding)
    safeY = window.innerHeight - h - padding;

  iPop.style.background = colors.getGameColor("iPop");
  iPop.style.borderColor = colors.getGameColor("accent");
  iPop.style.top = safeY + "px";
  iPop.style.left = safeX + "px";
};

eventHub.registerEvent("click", "iClose", close);
eventHub.registerEvent("click", "iBehinderCloseIPop", close);

export const iPop = {
  render,
};
